var exports = {
  "oC": "callToAction__mK-oaK",
  "qV": "skeleton__uXFVDT",
  "Qs": "content__TaydNv",
  "eu": "contentTitle__UzLs08",
  "c$": "contentDescription__kMdr9P",
  "o1": "actions__MV7pj9",
};

module.exports = exports;
